
export const GRID_COMPACTION_TYPE = "horizontal"; // Can be set to vertical or horizontal or none.